<template>
    <button class="fluke-btn" v-bind:class="{ 'fluke-grey': grey, 'fluke-red': red }">
        <slot />
    </button>
</template>

<style lang="scss">
.fluke-btn {
    background-color: $accent-color;
    padding: 10px 20px;
    width: 230px;
    @extend %default-borderRadius;
    @extend %default-shadow;

    &:hover {
        font-weight: 900;
    }

    &.fluke-grey {
        background-color: #e0e0e0;
        box-shadow: none;
    }
    &.fluke-red {
        background-color: #FF0000;
        box-shadow: none;
        color: #FFFFFF;
        font-weight: 500;
    }
}
.side-card 
{
    .fluke-btn {
        background-color: #e0e0e0;
        box-shadow: none;
        width: 100%;
        cursor: pointer;

        &:hover
        {
            background-color: $accent-color;
            @extend %default-shadow;
        }
    }
}
</style>

<script>
export default {
    data: function() {
        return {
            grey: false,
            red: false
        }
    },
    created: function() {
        if( typeof this.$attrs.color !== 'undefined' &&  this.$attrs.color == 'grey' )
        {
            this.grey = true;
        } else if( typeof this.$attrs.color !== 'undefined' &&  this.$attrs.color == 'red' ) {
            this.red = true;
        }
    }
}
</script>

